import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { Apple, Play, Tag } from "lucide-react";

// Reusable Book / Packages / Download App CTA band
export const CtaBand = ({
  title = "Ready To Train With Purpose?",
  subtitle = "Your first session is free. Meet a coach, tour the facility, and build your plan.",
  variant = "dark",
}) => {
  const { settings } = useSite();
  const dark = variant === "dark";
  return (
    <section className={dark ? "relative overflow-hidden bg-black py-16 sm:py-20 text-white grain" : "relative overflow-hidden bg-brand py-16 sm:py-20 text-white"}>
      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center gap-5 px-4 sm:px-6 text-center">
        <h2 className="display-title text-4xl sm:text-5xl">{title}</h2>
        <p className={dark ? "max-w-xl text-white/70" : "max-w-xl text-white/90"}>{subtitle}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <a href={settings.exercise_booking_url} target="_blank" rel="noopener noreferrer" data-testid="cta-band-book" className={dark ? "inline-flex items-center rounded-md bg-brand px-6 py-3.5 text-sm font-semibold uppercase tracking-wide text-white hover:bg-[hsl(var(--brand-red-deep))] transition-colors" : "inline-flex items-center rounded-md bg-black px-6 py-3.5 text-sm font-semibold uppercase tracking-wide text-white hover:bg-black/80 transition-colors"}>Book Intro Workout</a>
          <Link to="/packages" data-testid="cta-band-packages" className="inline-flex items-center gap-2 rounded-md border border-white/30 bg-white/5 px-6 py-3.5 text-sm font-semibold uppercase tracking-wide text-white hover:bg-white/10 transition-colors"><Tag className="h-4 w-4" /> View Packages</Link>
          <Link to="/contact" data-testid="cta-band-app" className="inline-flex items-center gap-2 rounded-md border border-white/30 bg-white/5 px-6 py-3.5 text-sm font-semibold uppercase tracking-wide text-white hover:bg-white/10 transition-colors"><Apple className="h-4 w-4" /><Play className="h-4 w-4" /> Download App</Link>
        </div>
      </div>
    </section>
  );
};
